module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageBookings.svg?b4c096e6";